import React from 'react';
import styled from '@emotion/styled';
const Wrapper = styled.h2 `
  color: #3f414d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: normal;
  text-transform: uppercase;
  margin: 10px 10px 5px 10px;
  text-align: ${({ align }) => align || 'left'};
`;
const TextButton = styled.div `
  width: 43%;
  display: inline-block;
  padding: 10px 5px;
  border: 1px solid #eeee;
  margin-left: 10px;
  margin-bottom: 12px;
  border-radius: 3px;
`;
const TextOnly = styled.div `
  width:100%;
  padding: 0px 0px 10px 0px
`;
const TextGrid = (widgetData) => {
    const { params, children } = widgetData;
    const { title, titleAlign, } = params;
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { align: titleAlign }, title),
        React.createElement(TextOnly, null, children && children.map((child) => (React.createElement(TextButton, null, child))))));
};
export default TextGrid;
